/**
 * Copyright (c) 2013-present, Facebook, Inc. All rights reserved.
 *
 * This file provided by Facebook is for non-commercial testing and evaluation
 * purposes only. Facebook reserves all rights not expressly granted.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * FACEBOOK BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
 * ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
'use strict';

exports.__esModule = true;
exports.TextBlock = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Chip = require('material-ui/Chip');

var _Chip2 = _interopRequireDefault(_Chip);

require('prismjs/themes/prism.css');

var _prismjs = require('prismjs');

var _prismjs2 = _interopRequireDefault(_prismjs);

require('prismjs/components/prism-php.js');

require('prismjs/components/prism-sql.js');

require('prismjs/components/prism-smarty.js');

require('prismjs/components/prism-jsx.js');

require('prismjs/components/prism-graphql.js');

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CodeOutputBlockPropTypes = {};
var CodeOutputBlockDefaultProps = {
  lang: "php"
};

var styles = function styles(theme) {
  if (!theme) {
    return {};
  }

  return {
    chip: {
      margin: theme.spacing.unit,
      height: 25,
      cursor: 'pointer',
      '&.active': {
        backgroundColor: theme.palette.secondary[500],
        '& .label': {
          color: theme.palette.secondary.contrastDefaultColor
        }
      }
    },
    svgIcon: {},
    row: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap'
    }
  };
};

var CodeOutputBlock = function (_React$Component) {
  _inherits(CodeOutputBlock, _React$Component);

  function CodeOutputBlock(props) {
    _classCallCheck(this, CodeOutputBlock);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      lang: props.lang
    };
    return _this;
  }

  CodeOutputBlock.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.lang != this.state.lang) {
      this.setState({
        lang: nextProps.lang
      });
    }

    return true;
  };

  CodeOutputBlock.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.content) {
      this.props.onClick();
    }
  };

  CodeOutputBlock.prototype.render = function render() {
    var output;
    var language;
    var lang = this.state.lang;

    if (typeof _prismjs2.default.languages[lang] == "undefined") {
      console.error("Unsupported language '" + lang + "'");
      lang = this.defaultLang;
    }

    if (this.props.content) {
      output = _prismjs2.default.highlight(this.props.content, _prismjs2.default.languages[lang]);
    }

    return _react2.default.createElement('div', {
      className: 'text-content',
      dangerouslySetInnerHTML: {
        __html: output
      },
      onClick: this.props.onClick
    });
  };

  return CodeOutputBlock;
}(_react2.default.Component);

CodeOutputBlock.propTypes = process.env.NODE_ENV !== "production" ? CodeOutputBlockPropTypes : {};
CodeOutputBlock.defaultProps = CodeOutputBlockDefaultProps;
var propTypes = {};
var defaultProps = {
  lang: "php" // fullView: true,

};

var TextBlock = exports.TextBlock = function (_React$Component2) {
  _inherits(TextBlock, _React$Component2);

  function TextBlock(props) {
    _classCallCheck(this, TextBlock);

    var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this, props));

    _this2.state = {
      editMode: false,
      lang: _this2._getLang() || props.lang,
      allow_edit: props.blockProps.allow_edit
    };

    _this2._onClick = function () {
      // alert(!this.state.allow_edit);
      // alert(this.state.editMode);
      if (!_this2.state.allow_edit) {
        return;
      }

      if (_this2.state.editMode) {
        return;
      }

      _this2.setState({
        editMode: true,
        textValue: _this2._getValue()
      }, function () {
        _this2._startEdit();
      });
    };

    _this2._onValueChange = function (evt) {
      var value = evt.target.value;

      _this2.setState({
        textValue: value
      });
    };
    /*
    *   Сохранение.
    *   Если контента нет, то удаляем этот блок
    * */


    _this2._save = function () {
      var value = _this2.state.textValue;

      if (value !== '') {
        var entityKey = _this2.props.block.getEntityAt(0);

        var newContentState = _this2.props.contentState.mergeEntityData(entityKey, {
          content: _this2.state.textValue,
          lang: _this2.state.lang
        });

        _this2.setState({
          invalidTeX: false,
          editMode: false,
          textValue: null
        }, _this2._finishEdit.bind(_this2, newContentState));
      } else {
        _this2._remove();
      }
    };

    _this2._remove = function () {
      _this2.props.blockProps.onRemove(_this2.props.block.getKey());
    };

    _this2._startEdit = function () {
      _this2.props.blockProps.onStartEdit(_this2.props.block.getKey());
    };

    _this2._finishEdit = function (newContentState) {
      _this2.props.blockProps.onFinishEdit(_this2.props.block.getKey(), newContentState);
    };

    return _this2;
  }

  TextBlock.prototype._getData = function _getData() {
    var data = this.props.contentState.getEntity(this.props.block.getEntityAt(0)).getData();
    return data;
  };

  TextBlock.prototype._getValue = function _getValue() {
    var content = this._getData()['content']; // if(
    //   this.state.editMode &&
    //   content == 'Кликните чтобы начать редактирование'
    // ){
    //   content = '';
    // }


    return content;
  };

  TextBlock.prototype._getLang = function _getLang() {
    var lang = this._getData()['lang']; // if(
    //   this.state.editMode &&
    //   content == 'Кликните чтобы начать редактирование'
    // ){
    //   content = '';
    // }


    return lang;
  }; // _onTab(event) {
  //   this._onChange(RichUtils.onTab(event, this.state.editorState, 6));
  // }


  TextBlock.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.blockProps.allow_edit != this.state.allow_edit) {
      this.setState({
        allow_edit: nextProps.blockProps.allow_edit
      });
    }

    return true;
  };

  TextBlock.prototype.render = function render() {
    var _this3 = this;

    var classes = this.props.classes;
    var allow_edit = this.state.allow_edit;
    var texContent = null;

    if (this.state.editMode) {
      // if (this.state.invalidTeX) {
      //   texContent = '';
      // } else {
      //   texContent = this.state.textValue;
      // }
      texContent = this.state.textValue; // if(texContent == 'Кликните чтобы начать редактирование'){
      //   texContent = '';
      // }
    } else {
      if (this.props.blockProps.fullView === false) {
        return null;
      }

      texContent = this._getValue();
    }

    var className = 'Editor-text';

    if (this.state.editMode) {
      className += ' Editor-activeText';
    }

    if (allow_edit) {
      className += ' edit';
    }

    var editPanel = null; // if (this.state.allow_edit && this.state.editMode) {

    if (this.state.editMode) {
      var buttonClass = 'Editor-saveButton'; // if (this.state.invalidTeX) {
      //   buttonClass += ' Editor-invalidButton';
      // }

      var height = "40px";
      var langs = [{
        value: "javascript",
        label: "Javascript"
      }, {
        value: "jsx",
        label: "JSX"
      }, {
        value: "graphql",
        label: "Graphql"
      }, {
        value: "php",
        label: "PHP"
      }, {
        value: "sql",
        label: "SQL"
      }, {
        value: "css",
        label: "CSS"
      }, {
        value: "html",
        label: "HTML"
      }, {
        value: "smarty",
        label: "Smarty"
      }];
      var chips = [];
      langs.map(function (item) {
        var className = [classes.chip];

        if (item.value == _this3.state.lang) {
          className.push("active");
        }

        chips.push(_react2.default.createElement(_Chip2.default, {
          key: item.value,
          label: item.label,
          className: className.join(" "),
          labelClassName: 'label',
          onClick: function onClick() {
            _this3.setState({
              lang: item.value
            });
          }
        }));
      });
      editPanel = _react2.default.createElement('div', {
        className: 'Editor-panel'
      }, _react2.default.createElement('div', {
        className: classes.row
      }, chips), _react2.default.createElement('textarea', {
        className: 'Editor-textValue',
        onChange: this._onValueChange,
        ref: 'textarea',
        value: this.state.textValue
      }), _react2.default.createElement('div', {
        className: 'Editor-buttons'
      }, _react2.default.createElement('button', {
        className: buttonClass,
        disabled: this.state.invalidTeX,
        onClick: this._save
      }, 'Сохранить'), _react2.default.createElement('button', {
        className: 'Editor-removeButton',
        onClick: this._remove
      }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")));
    }

    return _react2.default.createElement('div', {
      className: className
    }, _react2.default.createElement(CodeOutputBlock, {
      content: texContent,
      lang: this.state.lang,
      onClick: this._onClick
    }), editPanel);
  };

  return TextBlock;
}(_react2.default.Component);

TextBlock.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
TextBlock.defaultProps = defaultProps;
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(TextBlock, props);
});